import React, { useEffect, useState } from 'react'
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Card, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { ArrowCircleRightOutlined } from '@mui/icons-material';

const RenderCommentsTable = ({ comments }) => {
 
  if (!Array.isArray(comments) || comments.length === 0) {
	return <span>-</span>;
  }

  return (
	<SoftBox sx={{ overflowX: 'auto' }}>
	  <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
		<Table sx={{ minWidth: 400 }} size="small" aria-label="comments table">

		  <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
			<TableCell sx={{ fontWeight: 'bold' }}>Text</TableCell>
			<TableCell sx={{ fontWeight: 'bold' }} align="right">Date</TableCell>
		  </TableRow>

		  <TableBody>
			{comments.map((comment) => (
			  <TableRow
				key={comment._id}
				sx={{ '&:last-child td, &:last-child th': { border: 0 } }}

			  >
				<TableCell component="th" scope="row"  sx={{
				// whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				maxWidth: '700px', // adjust based on your table width
				cursor: 'pointer',
			  }}> 
				  {comment.text}
				</TableCell>
				<TableCell align="right">
				  {moment(comment.date).format('DD MMM YYYY')}
				</TableCell>
			  </TableRow>
			))}
		  </TableBody>
		</Table>
	  </TableContainer>
	</SoftBox>
  );
};
const Index = () => {
	const params = useParams()
	const Navigate = useNavigate()
	const [allData, setAllData] = useState({})
	const getDetailById = async () => {
		try {
			const res = await service.complaint.getDetailById(params.id);
			setAllData(res?.data?.data)
		} catch (error) {
			console.error('Error fetching user details:', error);
		}
	};

	useEffect(() => {
		if (params?.id) {
			getDetailById();
		}
	}, []);

	
	return (
		<DashboardLayout>
			<DashboardNavbar />
			<Card className="glassmorphism-card" sx={{ padding: 3, boxShadow: 2 }}>
				<SoftBox sx={{ display: 'flex', gap: 2 }}>
					<SoftBox
						variant="outlined"
						color="info"
						style={{ cursor: "pointer" }}
						onClick={() => Navigate(-1)}
					>
						<ArrowCircleRightOutlined
							style={{ transform: "rotate(180deg)", color: "#141414" }}
						/>
					</SoftBox>
					<SoftTypography variant="h6" fontWeight="bold" mb={3}>
						Update Report
					</SoftTypography>
				</SoftBox>


				 {[
							{ label: 'Name', value: allData?.name },
							{ label: 'Email', value: allData?.email },
							{ label: 'Request', value: allData?.message },
							{ label: 'Mobile', value: allData?.mobileNumber },
							{
							  label: 'Created',
							  value: allData?.createdAt
								? moment(allData.createdAt).format('DD/MM/YYYY')
								: '-'
							},
							{ label: 'Comment', value: allData?.comment || '-' },
						  ].map((item, i) => (
							<SoftBox display="flex" mb={2} key={i} gap={1.5} alignItems="baseline">
							  <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">{item.label}</SoftTypography>
							  <SoftTypography variant="button" fontWeight="bold" textTransform="capitalize">:</SoftTypography>
							  {item?.label === 'Comment' ? <RenderCommentsTable comments={item?.value} /> : <SoftTypography variant="button" fontWeight="regular" color="text">{item.value}</SoftTypography>}
							</SoftBox>
						  ))}
			</Card>

		</DashboardLayout>
	)
}

export default Index